import { Injectable }               from '@angular/core';

import { Observable }               from 'rxjs';

import { BaseService }              from '@mo-tools-engine/common';
import { SessionApiService }        from './session-api.service';

@Injectable()
export class SessionService extends BaseService<any> {

  // --- Service Constructor ---

  constructor(protected resourceService: SessionApiService) {

    super(resourceService);

  }

  // --- Session Service Methods ---

  public loggedInAs(): Observable<any> {

    return this.loadItem();

  }

  public logOut(): Observable<any> {

    return this.deleteItem();

  }

  // --- Base Service Overrides ---

  protected onResourceLoaded(resource: any): void {

    this.item = resource;
    super.onResourceLoaded(resource);

  }


}